﻿package org.zq.pixelset.model

import androidx.compose.ui.graphics.ImageBitmap

data class ImageItem(
    val id: String,
    val picked: PickedImage,
    val thumbnail: ImageBitmap,
    val originalWidth: Int,
    val originalHeight: Int,
    val originalBitmap: ImageBitmap,
    val settings: ImageSettings = ImageSettings(),
    val loadWarning: String? = null,
    val lastProcessError: String? = null,
    val processedResult: ProcessedResult? = null,
    val processedBitmap: ImageBitmap? = null,
    val isProcessing: Boolean = false,
)
